import { GetAllRelatoriosByIdProcessoAndIdUnidadeGerencia } from "@services/Relatorio/Index";

export default function ValidationsEditSolicitacao() {

    async function validateFields(data, processoItemList) {

        if (!data.prazoSolicitacao) {
            return { campo: "prazoSolicitacao", message: "Selecione um prazo para esta solicitação." };
        }

        const hasNoSelectedItem = !processoItemList.some((item) => item.flagSelecionado);

        if (hasNoSelectedItem) {
            return { campo: "itensProcesso", message: "Pelo menos um item do processo deve ser associado à solicitação." };
        }

        return null;
    }

    async function validateTemplateEmailRelatorio(templateEmailRelatorio) {
        if (!templateEmailRelatorio) {
            return {
                campo: "templateEmailRelatorio",
                message: "Por favor, selecione um template de e‑mail para o relatório antes de enviá‑lo à Unidade/Gerência."
            };
        }

        return null;
    }

    // Verifica se há pelo menos um relatório anexado o mesmo processo e unidade/gerencia
    async function validateAnexoRelatorio(idProcesso, idUnidadeGerencia) {

        try {
            const resposta = await GetAllRelatoriosByIdProcessoAndIdUnidadeGerencia(
                1, 100,
                idProcesso,
                idUnidadeGerencia
            );

            const relatorios = resposta?.items || [];

            if (relatorios.length === 0) {
                return {
                    html: `
                            <p>Nenhum Relatório foi anexado a esta solicitação</p>
                            <p><strong>Um Relatório deve ser anexado.</strong></p>
                        `,
                    missing: true,
                };
            }

            return null; // tudo certo
        } catch (error) {
            return {
                html: `
                    <p>Erro ao verificar os relatórios:</p>
                    <p><strong>Não foi possível validar se existe um relatório anexado.</strong></p>
                    `,
                missing: true,
            };
        }
    }

    return {
        validateFields,
        validateTemplateEmailRelatorio,
        validateAnexoRelatorio
    };
}
